import { createAuthClient } from "better-auth/react";
import { emailOTPClient } from "better-auth/client/plugins";

const backendUrl = import.meta.env.VITE_API_URL || "https://preview-mwrigabbviyq.dev.vibecode.run";

export const authClient = createAuthClient({
  baseURL: backendUrl,
  plugins: [emailOTPClient()],
  fetchOptions: {
    credentials: "include",
  },
});

export const { useSession, signOut } = authClient;

// Admin email whitelist
export const ADMIN_EMAILS = [
  "brian@allenanalysis.com",
  "allenanalysisofficial@gmail.com",
  "teddyoweh@gmail.com",
  "eoallen1@gmail.com",
  "admin@allenanalysis.com",
];

/**
 * Check if a user is an admin based on their email
 */
export function isUserAdmin(user: { email?: string | null } | null | undefined): boolean {
  if (!user?.email) return false;
  return ADMIN_EMAILS.includes(user.email.toLowerCase());
}
